export default "__VITE_PUBLIC_ASSET__b60d3461__"